import gql from 'graphql-tag';

export const credentialOAuthOneDriveFragment = gql`
  fragment credentialOAuthOneDriveFragment on CredentialOAuthOneDrive {
    dokkioClass
    isPersonal
  }
`;
export default credentialOAuthOneDriveFragment;
